import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './scss/login.scss';
import '../Home/Error/errors.scss';
import huggies from './images/Texto.png';

import { API_BASE } from "../config/api";

const ForgotPassword = () => {
  const _url = API_BASE;
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg('');
    if (!email) { setMsg('Ingresa tu correo para continuar.'); return; }
    setIsLoading(true);
    try {
      await fetch(`${_url}/assistant/password/forgot`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      // Siempre mensaje genérico (no filtramos existencia del correo)
      setSent(true);
      setMsg('Si el correo está vinculado con un usuario existente, te enviamos un enlace para restablecer la contraseña.');
    } catch {
      setSent(true);
      setMsg('Si el correo está vinculado con un usuario existente, te enviamos un enlace para restablecer la contraseña.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Panel izquierdo: mismo layout que Login */}
      <div className="image-container">
        <img src={huggies} alt="Huggies Product" />
    
      </div>

      {/* Panel derecho */}
      <div className="login-form">
        <img src="/logoF.png" alt="Logo" className="logo" />
        <h2 className="form-title">Recuperar contraseña</h2>
        {sent ? (
          <>
            <p className="hint">{msg}</p>
            <Link className="btn-ghost" to="/">Volver al inicio de sesión</Link>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <label htmlFor="email" className="input-label">Correo registrado</label>
            <input
              id="email"
              type="email"
              placeholder="correo@empresa.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" disabled={isLoading}>
              {isLoading ? <div className="loader"></div> : 'Enviar enlace'}
            </button>
            {msg && (
              <div className="form-inline-alert form-inline-alert--error">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                  <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
                  <path d="M15 9L9 15M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <span>{msg}</span>
              </div>
            )}
            <div className="form-footer">
              <span>¿Ya lo recordaste?</span> <Link to="/">Inicia sesión</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
